export const environment = {
  production: true,
  url: "/api/"
};
